module.exports = __webpack_public_path__ + "img/首页banner3.5bff3e6d.png";